import type { Role } from 'api-client/keystone.model'

export enum RolePageTabs {
  Predefined = 'predefined',
  Custom = 'custom',
}

export interface IRolesSelector extends Role {
  name: string
  description: string
}

export enum RoleScope {
  System = 'system',
  Domain = 'domain',
  Tenant = 'tenant',
}
